import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/jerry.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "circularImage" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Jerry"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "nameText" }, "Jerry", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Grid = _resolveComponent("Grid")!
  const _component_ChatHistory = _resolveComponent("ChatHistory")!
  const _component_MessageComposer = _resolveComponent("MessageComposer")!
  const _component_MoreMenu = _resolveComponent("MoreMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "chat",
    style: _normalizeStyle('font-family:' + this.$store.state.font)
  }, [
    _hoisted_1,
    _createVNode(_component_Grid),
    _createVNode(_component_ChatHistory),
    _createVNode(_component_MessageComposer),
    _createElementVNode("div", {
      id: "senderInfo",
      class: _normalizeClass(["foregr onTop", { senderInfo_hidden: !_ctx.showHeader }])
    }, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_MoreMenu)
    ], 2)
  ], 4))
}